import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import classNames from 'classnames';

import IconButton from '@mui/material/IconButton'
import Paper from '@mui/material/Paper'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';

import { getIsHeaderNavDisplayed } from 'cityads-v3/reducers/header';

import classes from './HeaderNav.scss';
import { RootState } from 'cityads-v3/types/reducer';

export default function HeaderNav() {
  const location = useLocation()

  const title = useSelector((state: RootState) => state.header.title)
  const backlink = useSelector((state: RootState) => state.header.backlink)
  const backlinkText = useSelector((state: RootState) => state.header.backlinkText)
  const menu = useSelector((state: RootState) => state.header.menu)
  const menuShow = useSelector((state: RootState) => state.header.menuShow)
  const menuValue = useSelector((state: RootState) => state.header.menuValue)
  const menuDocked = useSelector((state: RootState) => state.menu.docked)
  const isMobile = useSelector((state: RootState) => state.app.isMobile)
  const isLoggedIn = useSelector((state: RootState) => state.auth.isLoggedIn)

  const showNav = getIsHeaderNavDisplayed({ title, menuShow, menu, backlink });
  const showMenu = menuShow && menu?.length

  if (!showNav) {
    return null
  }

  return (
    <Paper square className={classNames(classes.headerNav, {
      [classes.headerNavDocked]: menuDocked && !isMobile,
      [classes.headerNavMobile]: isMobile || (!isMobile && !isLoggedIn)
    })}>
      {backlink && (
        <Tooltip title={backlinkText}>
          <IconButton
            component={Link}
            to={backlink}
            className={classes.backlink}
            size="large"
          >
            <ArrowBackOutlinedIcon />
          </IconButton>
        </Tooltip>
      )}

      {title && (
        <Typography
          color="textPrimary"
          variant="h1"
          sx={{
            fontSize: '24px',
            fontWeight: 'normal',
            margin: '0 32px',

            '@container header (width < 768px)': {
              ml: '16px',
            },
          }}
        >
          {title}
        </Typography>
      )}

      {showMenu && (
        <Tabs
          value={menuValue}
          indicatorColor="primary"
          textColor="primary"
          variant={isMobile ? 'scrollable' : 'standard'}
          classes={{
            root: classes.tabs
          }}
        >
          {menu.map(item => (
            <Tab
              key={item.id}
              label={item.title + (item.total ? ' (' + item.total + ')' : '')}
              value={item.id}
              to={item.onlyPathname ? { ...location, pathname: item.route } : item.route}
              component={item.route ? Link : undefined}
              classes={{ root: classes.tab }}
            />
          ))}
        </Tabs>
      )}
    </Paper>
  )
}
